import { useRouter } from "next/router";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import MainLayout from "../../components/MainLayout/MainLayout";
import { MatchupBreakdowns } from "../../components/premiumTools/MatchupBreakdowns";
import { ModelSandbox } from "../../components/premiumTools/ModelSandbox";
import { Scores } from "../../components/premiumTools/Scores";
import { TrendFinder } from "../../components/premiumTools/TrendFinder";
import { AdjSQ } from "../../components/stats-explained/AdjSQ";
import { BadPossessions } from "../../components/stats-explained/BadPossessions";
import { GoodPossessions } from "../../components/stats-explained/GoodPossessions";
import { MiscStats } from "../../components/stats-explained/MiscStats";
import { PassingStats } from "../../components/stats-explained/PassingStats";
import { RecordLuck } from "../../components/stats-explained/RecordLuck";
import { SqPoints } from "../../components/stats-explained/SqPoints";
import { SqRecord } from "../../components/stats-explained/SqRecord";
import { StatsExplained } from "../../components/stats-explained/StatsExplained";
import { PremiumToolsSideBar } from "../../nextJSComponents/PremiumToolsSideBar";
import { Sidebar } from "../../nextJSComponents/SideBar";
import { appServerSideProps } from "../../utils/getAppService";

const sidebarItems = [
  {
    title: "Trend Finder",
    link: "",
  },
  {
    title: "Matchup Breakdowns",
    link: "#matchup-breakdowns",
  },
  {
    title: "Scores",
    link: "#scores",
  },
  {
    title: "Model Sandbox",
    link: "#model-sandbox",
  },
];

const PremiumToolsPage = () => {
  const router = useRouter();
  console.log(router);
  const hashName = router.asPath.split(`${router.route}`).pop();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (hashName != "") {
      document.title = "ShotQuality Bets | " + hashName;
    } else {
      document.title = "ShotQuality Bets | Premium Tools";
    }
  }, [hashName]);

  return (
    <>
      <MainLayout>
        <main id="ContentBox">
          <div className="StatsExplained">
            <section className="page-content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-3">
                    <PremiumToolsSideBar items={sidebarItems} />
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-9">
                    <div className="Statside">
                      {hashName === "" ? <TrendFinder /> : null}
                      {hashName === "#matchup-breakdowns" ? <MatchupBreakdowns /> : null}
                      {hashName === "#scores" ? <Scores /> : null}

                      {hashName === "#model-sandbox" ? <ModelSandbox /> : null}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </MainLayout>
    </>
  );
};

export default PremiumToolsPage;
